import { selector, selectorFamily } from 'recoil';
import { PartySubTypeEnum, } from '@zurich/api/party';
import { allValid, alwaysValidValidationSelector } from '@zurich/common/recoil';
import { localPartyBusinessNameValidationSelector, localPartyCityValidationSelectorFamily, localPartyCountryValidationSelectorFamily, localPartyFirstNameValidationSelector, localPartyHouseNumberFromValidationSelectorFamily, localPartyHouseNumberToValidationSelectorFamily, localPartyLastNameValidationSelector, localPartyLegalFormNotRequiredValidationSelector, localPartyOrganizationNameValidationSelector, localPartyOrganizationTypeValidationSelector, localPartyPostalCodeValidationSelectorFamily, localPartyStreetValidationSelectorFamily, localPartySubTypeSelector, localPartySubTypeValidationSelector, } from '../';
export const createLimitationOfTransferabilityPartyFormValidationSelector = selector({
    key: 'validation/local/limitationOfTransferabilityPartyForm',
    get: ({ get }) => {
        const partySubType = get(localPartySubTypeSelector);
        return partySubType === PartySubTypeEnum.UNTERNEHMEN ||
            partySubType === PartySubTypeEnum.VEREIN
            ? allValid({
                partySubType: get(localPartySubTypeValidationSelector),
                partyLegalForm: get(localPartyLegalFormNotRequiredValidationSelector),
                partyOrganizationName: get(localPartyOrganizationNameValidationSelector),
            })
            : allValid({
                partySubType: get(localPartySubTypeValidationSelector),
                partyFirstName: get(localPartyFirstNameValidationSelector),
                partyLastName: get(localPartyLastNameValidationSelector),
                partyLegalForm: partySubType === PartySubTypeEnum.PRIVATPERSON
                    ? get(alwaysValidValidationSelector)
                    : get(localPartyLegalFormNotRequiredValidationSelector),
                partyBusinessName: partySubType === PartySubTypeEnum.EINZELUNTERNEHMER
                    ? get(localPartyBusinessNameValidationSelector)
                    : get(alwaysValidValidationSelector),
                partyOrganizationType: partySubType === PartySubTypeEnum.EINZELUNTERNEHMER
                    ? get(localPartyOrganizationTypeValidationSelector)
                    : get(alwaysValidValidationSelector),
            });
    },
});
export const createLimitationOfTransferabilityPartyCommunicationFormValidationSelectorFamily = selectorFamily({
    key: 'validation/local/limitationOfTransferabilityPartyCommunicationForm',
    get: ({ communicationRoleGeo }) => ({ get }) => allValid({
        partyCountry: get(localPartyCountryValidationSelectorFamily(communicationRoleGeo)),
        partyPostalCode: get(localPartyPostalCodeValidationSelectorFamily(communicationRoleGeo)),
        partyCity: get(localPartyCityValidationSelectorFamily(communicationRoleGeo)),
        partyStreet: get(localPartyStreetValidationSelectorFamily(communicationRoleGeo)),
        partyHouseNumberFrom: get(localPartyHouseNumberFromValidationSelectorFamily(communicationRoleGeo)),
        partyHouseNumberTo: get(localPartyHouseNumberToValidationSelectorFamily(communicationRoleGeo)),
    }),
});
